import initializeSvelteApp from "common/initializeSvelteApp";
import App from "./App";

initializeSvelteApp({
  component: App,
  target: ".js-ticketbuyer-playlist",
  props: (element) => {
    return {
      bundle: element.getAttribute("data-bundle"),
      organizer: element.getAttribute("data-organizer"),
      videos: JSON.parse(element.getAttribute("data-playlists")),
      url: element.getAttribute("data-url"),
      strings: JSON.parse(element.getAttribute("data-strings")),
    };
  },
});
